export default __webpack_public_path__ + "static/media/html.857acac6.png";